import { KPI_UNIT } from 'constants/staff/kpiUnit.const';

const fromDtoToKpiUnit = (dto) => {
  if ('percentage' === dto) return KPI_UNIT.percent;
  if ('money' === dto) return KPI_UNIT.currency;
  if ('number' === dto) return KPI_UNIT.count;

  return KPI_UNIT.count;
};

export default fromDtoToKpiUnit;
